import { render, staticRenderFns } from "./WesInfoAccordion.vue?vue&type=template&id=e3885eb4&scoped=true"
import script from "./WesInfoAccordion.vue?vue&type=script&lang=js"
export * from "./WesInfoAccordion.vue?vue&type=script&lang=js"
import style0 from "./WesInfoAccordion.vue?vue&type=style&index=0&id=e3885eb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3885eb4",
  null
  
)

export default component.exports